import { getLineOffsets } from "~/components/get-line-offsets";

export function getLineRange(text: string, { startLine, endLine }: { startLine: number; endLine: number }) {
  const offsets = getLineOffsets(text);
  const startIndex = Math.max(0, startLine - 1);
  const endIndex = Math.min(offsets.length - 1, endLine - 1);

  if (startIndex >= offsets.length || startIndex > endIndex) {
    return "";
  }

  const startPos = offsets[startIndex];
  const endPos = endIndex + 1 < offsets.length ? offsets[endIndex + 1] : text.length;

  return text
    .slice(startPos, endPos)
    .replace(/\r?\n$/, "")
    .replace(/\r\n/g, "\n");
}
